import axios from 'axios';

const ENDPOINT = '/api/v1/lwadmin/profile';

export function enableFeature(profileId, feature) {
  return axios.post(`${ENDPOINT}/${profileId}/permission/${feature}/enable`, {
    authenticity_token: Livewire.formAuthenticityToken,
  });
}

export function disableFeature(profileId, feature) {
  return axios.post(`${ENDPOINT}/${profileId}/permission/${feature}/disable`, {
    authenticity_token: Livewire.formAuthenticityToken,
  });
}
